import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { useInicio } from "../../lib/inicio";

export default function SiteHeader() {
  const site = useInicio();
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = () => setNavOpen(false);

  // Enquanto a gaveta está aberta ela cobre a página, então trava o scroll do
  // fundo e deixa o Esc fechar.
  useEffect(() => {
    if (!navOpen) return undefined;

    function onKeyDown(e) {
      if (e.key === "Escape") setNavOpen(false);
    }

    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [navOpen]);

  // O menu só existe como gaveta no mobile; ao voltar para o desktop o CSS
  // devolve o nav para a barra, mas o estado (e o scroll travado) precisa cair.
  useEffect(() => {
    const mq = window.matchMedia("(min-width:881px)");
    const onChange = (e) => {
      if (e.matches) setNavOpen(false);
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <header className={`site-header${navOpen ? " nav-open" : ""}`}>
      <Link to="/" className="logo-wrap" onClick={closeNav}>
        <picture>
          <source
            type="image/avif"
            srcSet="/assets/img/logo-bivver-353.avif 353w, /assets/img/logo-bivver-706.avif 706w"
            sizes="353px"
          />
          <source
            type="image/webp"
            srcSet="/assets/img/logo-bivver-353.webp 353w, /assets/img/logo-bivver-706.webp 706w"
            sizes="353px"
          />
          <img
            className="logo-img"
            src="/assets/img/logo-bivver.png"
            width={353}
            height={88}
            alt="Bivver Empreendimentos"
          />
        </picture>
        <span className="brand-tagline">{site.marcaTagline}</span>
      </Link>
      <button
        type="button"
        className="nav-toggle"
        aria-label={navOpen ? "Fechar menu" : "Abrir menu"}
        aria-expanded={navOpen}
        aria-controls="site-nav"
        onClick={() => setNavOpen((open) => !open)}
      >
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
      </button>
      <div
        className={`nav-overlay${navOpen ? " open" : ""}`}
        onClick={closeNav}
        aria-hidden="true"
      />
      <nav id="site-nav" className={`main-nav${navOpen ? " open" : ""}`}>
        <Link to="/" onClick={closeNav}>
          {site.menuAbertura}
        </Link>
        <Link to="/empreendimentos" onClick={closeNav}>
          {site.menuEmpreendimentos}
        </Link>
        <Link to="/institucional" onClick={closeNav}>
          {site.menuInstitucional}
        </Link>
        <Link to="/pbqh" onClick={closeNav}>
          {site.menuPbqh}
        </Link>
        <Link to="/contato" onClick={closeNav}>
          {site.menuContato}
        </Link>
      </nav>
    </header>
  );
}
